import React from 'react';

const ServiceTile = ({ title, description, index = 0 }) => {
    const delayClass = `animation-delay-${Math.min(index + 1, 6)}00`;

    return (
        <div className={`glass-panel p-8 flex flex-col hover:shadow-lg transition-shadow duration-300 animate-fade-in-up opacity-0 ${delayClass}`}>
            <h3 className="text-xl font-bold mb-3 text-primary-blue">{title}</h3>
            <p className="text-text-light">{description}</p>
        </div>
    );
};

export default ServiceTile;
